import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const VehicleApi = createApi({
  reducerPath: "VehicleApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["VEHICLETYPE"],
  endpoints: (build) => ({
    // Public endpoints
    getAllVehicleTypes: build.query({
      query: ({ isActive, search = "", page, limit } = {}) => {
        const params = new URLSearchParams();

        if (isActive !== undefined && isActive !== "") {
          params.append("isActive", isActive);
        }

        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);
        if (search) params.append("search", search);

        return {
          url: `/vehicles?${params.toString()}`,
          method: "GET",
          headers: { "Content-Type": "application/json; charset=UTF-8" },
        };
      },
      providesTags: ["VEHICLETYPE"],
    }),

    getVehicleTypeById: build.query({
      query: ({ id }) => ({
        url: `/vehicles/${id}`,
        method: "GET",
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      }),
      providesTags: ["VEHICLETYPE"],
    }),

    // Admin endpoints - Updated for file upload
    createVehicleType: build.mutation({
      query: ({ name, iconFile }) => {
        const formData = new FormData();
        formData.append("name", name);
        if (iconFile) {
          formData.append("image", iconFile); // 'image' matches the multer field name
        }
        return {
          url: `/vehicles`,
          method: "POST",
          body: formData,
          // Don't set Content-Type header - browser will set it with boundary
        };
      },
      invalidatesTags: ["VEHICLETYPE"],
    }),

    updateVehicleType: build.mutation({
      query: ({ id, name, iconFile }) => {
        const formData = new FormData();
        if (name) formData.append("name", name);
        if (iconFile) {
          formData.append("image", iconFile); // 'image' matches the multer field name
        }
        return {
          url: `/vehicles/${id}`,
          method: "PUT",
          body: formData,
          // Don't set Content-Type header - browser will set it with boundary
        };
      },
      invalidatesTags: ["VEHICLETYPE"],
    }),

    deleteVehicleType: build.mutation({
      query: ({ id, hardDelete = false }) => ({
        url: `/vehicles/${id}?hardDelete=${hardDelete}`,
        method: "DELETE",
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      }),
      invalidatesTags: ["VEHICLETYPE"],
    }),

    toggleVehicleTypeStatus: build.mutation({
      query: ({ id }) => ({
        url: `/vehicles/${id}/toggle-status`,
        method: "PATCH",
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      }),
      invalidatesTags: ["VEHICLETYPE"],
    }),
  }),
});

export const {
  // Public hooks
  useGetAllVehicleTypesQuery,
  useLazyGetAllVehicleTypesQuery,
  useGetVehicleTypeByIdQuery,

  // Admin hooks
  useCreateVehicleTypeMutation,
  useUpdateVehicleTypeMutation,
  useDeleteVehicleTypeMutation,
  useToggleVehicleTypeStatusMutation,
} = VehicleApi;
